// src/locales/index.js

import { tr } from './tr';
import { en } from './en';

export const translations = {
    tr,
    en
};

export const getTranslation = (lang, key) => {
    const keys = key.split('.');
    let value = translations[lang];

    for (const k of keys) {
        value = value?.[k];
    }

    return value || key;
};